import React from "react"
import ArtworkDetailPage from "../../features/pages/ArtworkDetailPage"
import ArtworksErrorPage from "../../features/pages/ArtworksErrorPage"
import galleryApiService from "../../services/galleryApiService"
import { idExtractor } from "../../services/utils/idExtractor"

const ArtworkDetail = ({
  artworkDetails,
  relatedArtworks,
  errorCode,
  gallery,
}) => {
  if (errorCode && errorCode !== 200)
    return (
      <ArtworksErrorPage
        status={errorCode}
        artwork={artworkDetails}
        gallery={gallery}
      />
    )

  return (
    <ArtworkDetailPage
      artworkDetails={artworkDetails}
      relatedArtworks={relatedArtworks}
      gallery={gallery}
    />
  )
}

export const getServerSideProps = async ({ params }) => {
  const [id, ...rest] = idExtractor(params.id)
  try {
    const response = await galleryApiService.artwork(id)

    if (response.data.status !== 200) {
      return {
        props: {
          errorCode: response.data.status,
          artworkDetails: response.data,
        },
      }
    }

    const galleryResponse = await galleryApiService.gallery(
      response.data.galleryid,
    )

    return {
      redirect: {
        destination: `/galleries/${
          galleryResponse.data.domain
        }/artworks/${encodeURIComponent(params.id)}`,
        permanent: true,
      },
    }
  } catch (err) {
    return {
      props: {
        errorCode: 301,
        artworkDetails: {
          id: id,
        },
      },
    }
  }
}

export default ArtworkDetail
